import { AutoComplete, Button, Card, Flex, Layout, Spin } from 'antd'
import { DeleteOutlined } from '@ant-design/icons'
import { t } from 'i18next'
import React, { useContext, useEffect, useState } from 'react'
import { get, post } from '../../Common/api'
import BoxContext from './BoxContext'
import GlobalContext from '../GlobalContext'
import Title from 'antd/es/typography/Title'

const renderSearchItem = (place, _search) => ({
  value: place.id,
  key: place.id,
  extra: place,
  label: (
    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      <span>{place.normalized_name}</span>
      <span>{place.zip_code}</span>
    </div>
  )
})

export default function BoxClusterPage () {
  const [loading, setLoading] = useState(false)
  const [cluster, setCluster] = useState([])
  const [searchOptions, setSearchOptions] = useState([])
  const [searchValue, setSearchValue] = useState('')
  const { box } = useContext(BoxContext)
  const { notificationApi } = useContext(GlobalContext)

  const loadCluster = async () => {
    if (!box) return
    setLoading(true)
    await get({
      url: `admin/boxes/${box.id}/cluster`,
      params: {},
      onSuccess: (json) => {
        setCluster(json)
        setLoading(false)
      },
      onFailure: () => {
        setLoading(false)
      }
    })
  }

  const handleSearch = (search) => {
    if (search.length < 2) return
    get({
      url: 'public/postal_places',
      params: { search },
      onSuccess: (json) => {
        const filtered = json.filter(place => !cluster.find(c => c.id === place.id))
        setSearchOptions(filtered.map((place) => renderSearchItem(place, search)))
      }
    })
  }

  const addPostalPlace = (placeId) => {
    const option = searchOptions.find((o) => o.value === placeId)
    if (option) {
      const newCluster = [...cluster, option.extra]
      setCluster(newCluster)
      setSearchOptions([])
      setSearchValue('')
    }
  }

  const removePostalPlace = (placeId) => {
    setCluster(cluster.filter(place => place.id !== placeId))
  }

  const saveCluster = async () => {
    setLoading(true)
    await post({
      url: `admin/boxes/${box.id}/update_cluster`,
      params: { postal_place_ids: cluster.map(place => place.id) },
      notification: { api: notificationApi, state: 'update' },
      onSuccess: () => {
        setLoading(false)
      },
      onFailure: () => {
        setLoading(false)
      }
    })
  }

  const displayPostalPlace = (postalPlace) => {
    return (
      <Card style={{ marginTop: '1em' }}>
        <Flex align='center' gap='3em'>
          <Flex vertical>
            <Title level={5}>{postalPlace.normalized_name}</Title>
            <p>{`${postalPlace.zip_code} - INSEE: ${postalPlace.insee_code || '-'}`}</p>
          </Flex>
          <Button
            key="delete"
            type="text"
            danger
            icon={<DeleteOutlined />}
            onClick={() => removePostalPlace(postalPlace.id)}
          />
        </Flex>
      </Card>
    )
  }

  useEffect(() => {
    loadCluster()
  }, [box])

  return (
    <Layout style={{ padding: '1em', backgroundColor: 'white' }}>
      <h2>{t('Admin.BoxClusterPage.title')}</h2>
      <Spin spinning={loading}>
        <div style={{ marginBottom: '1em' }}>
          <AutoComplete
            style={{ width: 350 }}
            options={searchOptions}
            value={searchValue}
            onChange={setSearchValue}
            showSearch={{ onSearch: handleSearch }}
            onSelect={addPostalPlace}
            placeholder={t('Admin.BoxClusterPage.searchPlaceholder')}
          />
        </div>
        <div style={{ overflowY: 'scroll', maxHeight: '54vh' }}>
          <Flex wrap gap='1em'>
            {[...cluster].sort((a, b) => (a.insee_code || '').localeCompare(b.insee_code || '')).map(displayPostalPlace)}
          </Flex>
        </div>

        <Button
          type="primary"
          onClick={saveCluster}
          style={{ marginTop: '1em' }}
        >
          {t('Admin.btn.submit')}
        </Button>
      </Spin>
    </Layout>
  )
}
